import { createFileRoute } from '@tanstack/react-router'
import Reporting from '../components/reporting/Reporting'

export const Route = createFileRoute('/_a/reporting')({
  component: Reporting,
})
